/** biome-ignore-all lint/correctness/noUnusedImports: reason */

import { isThisQuarter } from "date-fns";
import isThisMonth from "date-fns/is_this_month";
import isThisSecond from "date-fns/is_this_second";
import isThisWeek from "date-fns/is_this_week";
import isThisYear from "date-fns/is_this_year";
import React, { createContext, useContext, useEffect, useState } from "react";

import {
  brandHelper,
  TotalKegsHelper,
  totalVolumeHelper,
} from "../../../app/helpers/volumeHelpers";

import { useAuth } from "../auth";
import { useReports } from "../reports";

const VolumeContext = createContext(null);

const VolumeByBrandProvider = ({ children }) => {
  const { reports_kegs_dispatched, getReport } = useReports();
  const { claims } = useAuth();

  const [pdfData, setPdfData] = useState(null);
  const [client, setClient] = useState();
  const [filteredKegs, setFilteredKegs] = useState([]);
  const [brand, setBrand] = useState();
  const [totalVolume, setTotalVolume] = useState(0);
  const [totalKegs, setTotalKegs] = useState(0);
  const [date, setDate] = useState();

  useEffect(() => {
    if (!claims?.companyLink) return () => {};
    return getReport("reports_kegs_dispatched", "companyLink");
  }, [
    claims.companyLink,
    getReport,
  ]);

  useEffect(() => {
    if (reports_kegs_dispatched) {
      const clientKegs = reports_kegs_dispatched.filter(keg => keg.clientLink);

      if (date) {
        if (date === "weekly") {
          const updatedKegs = clientKegs.filter(keg =>
            isThisWeek(keg.dateDispatched?.toDate())
          );

          if (brand) {
            brandHelper(
              client,
              brand,
              updatedKegs,
              setFilteredKegs,
              setTotalVolume,
              setTotalKegs
            );
          } else {
            const filteredTotalVolume = totalVolumeHelper(updatedKegs);
            const filteredTotalKegs = TotalKegsHelper(updatedKegs);

            setTotalVolume(filteredTotalVolume);
            setTotalKegs(filteredTotalKegs);
            setBrand(undefined);
            setFilteredKegs(updatedKegs);
          }
        }

        if (date === "monthly") {
          const updatedKegs = clientKegs.filter(keg =>
            isThisMonth(keg.dateDispatched?.toDate())
          );

          if (brand) {
            brandHelper(
              client,
              brand,
              updatedKegs,
              setFilteredKegs,
              setTotalVolume,
              setTotalKegs
            );
          } else {
            const filteredTotalVolume = totalVolumeHelper(updatedKegs);
            const filteredTotalKegs = TotalKegsHelper(updatedKegs);

            setTotalVolume(filteredTotalVolume);
            setTotalKegs(filteredTotalKegs);
            setBrand(undefined);
            setFilteredKegs(updatedKegs);
          }
        }

        if (date === "quartely") {
          const updatedKegs = clientKegs.filter(keg =>
            isThisQuarter(keg.dateDispatched?.toDate())
          );

          if (brand) {
            brandHelper(
              client,
              brand,
              updatedKegs,
              setFilteredKegs,
              setTotalVolume,
              setTotalKegs
            );
          } else {
            const filteredTotalVolume = totalVolumeHelper(updatedKegs);
            const filteredTotalKegs = TotalKegsHelper(updatedKegs);

            setTotalVolume(filteredTotalVolume);
            setTotalKegs(filteredTotalKegs);
            setBrand(undefined);
            setFilteredKegs(updatedKegs);
          }
        }
        if (date === "second") {
          const updatedKegs = clientKegs.filter(keg =>
            isThisSecond(keg.dateDispatched?.toDate())
          );
          if (brand) {
            brandHelper(
              client,
              brand,
              updatedKegs,
              setFilteredKegs,
              setTotalVolume,
              setTotalKegs
            );
          } else {
            const filteredTotalVolume = totalVolumeHelper(updatedKegs);
            const filteredTotalKegs = TotalKegsHelper(updatedKegs);

            setTotalVolume(filteredTotalVolume);
            setTotalKegs(filteredTotalKegs);
            setBrand(undefined);
            setFilteredKegs(updatedKegs);
          }
        }
        if (date === "year") {
          const updatedKegs = clientKegs.filter(keg =>
            isThisYear(keg.dateDispatched?.toDate())
          );

          if (brand) {
            brandHelper(
              client,
              brand,
              updatedKegs,
              setFilteredKegs,
              setTotalVolume,
              setTotalKegs
            );
          } else {
            const filteredTotalVolume = totalVolumeHelper(updatedKegs);
            const filteredTotalKegs = TotalKegsHelper(updatedKegs);

            setTotalVolume(filteredTotalVolume);
            setTotalKegs(filteredTotalKegs);
            setBrand(undefined);
            setFilteredKegs(updatedKegs);
          }
        }
      } else {
        if (brand) {
          brandHelper(
            client,
            brand,
            clientKegs,
            setFilteredKegs,
            setTotalVolume,
            setTotalKegs
          );
        } else {
          setFilteredKegs(clientKegs);

          const filteredTotalVolume = totalVolumeHelper(clientKegs);
          const filteredTotalKegs = TotalKegsHelper(clientKegs);

          setTotalVolume(filteredTotalVolume);
          setBrand(undefined);
          setTotalKegs(filteredTotalKegs);
        }
      }
    }
  }, [
    reports_kegs_dispatched,
    date,
    client,
    brand,
  ]);

  useEffect(() => {
    if (!brand) setClient(undefined);
  }, [
    brand,
  ]);

  return (
    <VolumeContext.Provider
      value={{
        brand,
        client,
        dispatchedVolume: filteredKegs,
        pdfData,
        setBrand,
        setClient,
        setDate,
        setPdfData,
        totalKegs,
        totalVolume,
      }}
    >
      {children}
    </VolumeContext.Provider>
  );
};

export default VolumeByBrandProvider;
export const useVolumeByBrand = () => useContext(VolumeContext);
